import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "px-4 py-0" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = ["href"];
const _hoisted_4 = { key: 1 };
const _hoisted_5 = ["href"];
import ConfiguratorLayout from '../Layouts/ConfiguratorLayout.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderCompletion',
    props: {
        order: {
            type: Object,
            required: true
        },
        success: {
            type: Boolean,
            required: true
        },
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ConfiguratorLayout, null, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        (props.success)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Vielen Dank für Ihre Bestellung", -1)),
                                _createElementVNode("p", null, [
                                    _cache[0] || (_cache[0] = _createTextVNode("Ihre Bestellung wird unter der Bestellnummer ", -1)),
                                    _createElementVNode("strong", null, _toDisplayString(props.order.orderId), 1),
                                    _cache[1] || (_cache[1] = _createTextVNode(" verarbeitet.", -1))
                                ]),
                                _cache[3] || (_cache[3] = _createElementVNode("p", null, "Falls Sie Ihre Bestellung noch nicht bezahlt haben, können Sie dies unter nachfolgendem Link erledigen:", -1)),
                                _createElementVNode("p", null, [
                                    _createElementVNode("a", {
                                        href: _ctx.route('orders.payments.store', props.order.uuid)
                                    }, "Zahlvorgang durchführen", 8, _hoisted_3)
                                ]),
                                _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                                _cache[5] || (_cache[5] = _createElementVNode("p", null, [
                                    _createTextVNode("Sie erhalten die Zahlungsdetails zusätzlich noch einmal per Mail zugesendet."),
                                    _createElementVNode("br"),
                                    _createTextVNode("Über den aktuellen Status Ihrer Bestellung informieren wir Sie zeitnah.")
                                ], -1))
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _cache[8] || (_cache[8] = _createElementVNode("h1", null, "Vielen Dank für Ihre Bestellung", -1)),
                                _createElementVNode("p", null, [
                                    _cache[6] || (_cache[6] = _createTextVNode("Ihre Bestellung wird unter der Bestellnummer ", -1)),
                                    _createElementVNode("strong", null, _toDisplayString(props.order.orderId), 1),
                                    _cache[7] || (_cache[7] = _createTextVNode(" verarbeitet.", -1))
                                ]),
                                _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-danger fw-bold" }, [
                                    _createTextVNode("Bei Abschluss Ihres Zahlvorgangs ist entweder ein Fehler aufgetreten oder Sie haben den Vorgang abgebrochen."),
                                    _createElementVNode("br"),
                                    _createTextVNode("Bitte starten Sie den Zahlvorgang erneut. Kontaktieren Sie Ihren Ansprechpartner, falls der Zahlvorgang erneut fehlschlägt.")
                                ], -1)),
                                _createElementVNode("p", null, [
                                    _createElementVNode("a", {
                                        href: _ctx.route('orders.payments.store', props.order.uuid)
                                    }, "Zahlvorgang durchführen", 8, _hoisted_5)
                                ])
                            ]))
                    ])
                ]),
                _: 1
            }));
        };
    }
});
